<template>
    <div>
        <select class="form-control" @input="changed">
            <option value>All</option>
            <option value='1'>Active</option>
            <option value='0'>Not Active</option>
        </select>
    </div>
</template>
<script>
export default {
    props: ['column'],
    methods: {
        changed(selected) {
            let res = {};

            res[`q_${this.column.key}`] = selected.target.value ? selected.target.value : null;

            this.$emit('input', res );
        }
    }
};
</script>



// WEBPACK FOOTER //
// resources/js/metronic/table/header/BooleanHeader.vue